import React from "react";

export default function MemoryIcon({ className, size = 14, strokeWidth = 1.5, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 14.25"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...rest}
    >
      <path d="M11.25 2.625C11.25 3.661 8.9 4.5 6 4.5S.75 3.66.75 2.625m10.5 0C11.25 1.589 8.9.75 6 .75S.75 1.59.75 2.625m10.5 0v9C11.25 12.661 8.9 13.5 6 13.5S.75 12.66.75 11.625v-9m10.5 3C11.25 6.661 8.9 7.5 6 7.5S.75 6.66.75 5.625m10.5 3C11.25 9.661 8.9 10.5 6 10.5S.75 9.66.75 8.625" />
    </svg>
  );
}
